<template>
    <div>
        <div class="d-flex align-items-center" style="margin-top: 12px;">
            <h5 class="mb-0">Словарь 1C</h5>
            <div class="d-flex ml-auto">
                <div>
                    <b-icon
                        v-if="$mq != 'sm'"
                        icon="search"
                        scale="1.3"
                        class="table-input-search_icon"
                        variant="secondary"
                    />
                    <input class="form-control table-input-search" type="search" placeholder="Поиск" v-model="filter">
                </div>
                <b-button
                    @click="getDictionary()"
                    size="sm"
                    variant="outline-secondary"
                    class="ml-2"
                    
                    :disabled="loading"
                >
                    <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
                </b-button>                                
                <button
                    :disabled="loading"
                    @click="isOpen = true"
                    class="btn btn-outline-primary ml-2"
                >
                    Создать запись
                </button>                
            </div>
        </div>

        <h5 class="mt-5 mb-4">Список значений</h5>
        <BdrOneCProperties 
            :records="filtredItems" 
        ></BdrOneCProperties>

        <BdrOneCSidebar
            :isOpen.sync='isOpen'
            @updateItem="getDictionary"
        ></BdrOneCSidebar>        
    </div>
</template>

<script>
import { API_BDR_1C_DICTIONARY } from '@/constants';
import BdrOneCProperties from '@/components/bdrPage/BdrOneCProperties';
import BdrOneCSidebar from '@/components/bdrPage/BdrOneCSidebar';

const initialDictionaryElement = () => (
    {
        name_from_file: '',
        bdr_dictionary_id: '',
        unit_percent: '',
        always_pass: 0,
        property: {}
    }
);

export default {
    name: "BDROneCdictionary",
    components: {
        BdrOneCProperties,
        BdrOneCSidebar
    },    
    data() {
        return {
            loading: false,
            dictionary: [],
            filter: '',
            isOpen: false
        };
    },

    computed: {
        filtredItems() {
            if (this.filter) {
                const search = this.filter.toLowerCase();
                return this.dictionary.filter(item => this.matchesSearch(item, search));
            } else {
                return this.dictionary;
            }         
        }
    },
    mounted() {
        this.getDictionary();
    },
    methods: {
        // !!!!!!!!!!!!!!!!!!!!! ПРОПИШИ always_pass
        getDictionary() {
            this.loading = true;
            axios.get(`${API_BDR_1C_DICTIONARY}?easylist=true`).then(({ data }) => {
                this.dictionary = data;             
                this.loading = false;
            });
        },

        matchesSearch(item, search) {
            if (item.name_from_file.toLowerCase().includes(search)) {
                return true;
            }
            if (item.property.external_number && item.property.external_number.toLowerCase().includes(search)) {
                return true;
            }
            if (item.children) {
                for (let child of item.children) {
                    if (this.matchesSearch(child, search)) {
                        return true;
                    }
                }
            }
            return false;
        }        
    },
};
</script>